/* ==========================================================================
   UKR-TEC · живий чат із консультантом

   Покупець пише у віджеті → бекенд (Cloudflare Worker, /api/chat/*) пересилає
   в Telegram-групу консультантів → відповідь приходить сюди через WebSocket.
   Якщо WebSocket недоступний (корпоративний проксі тощо) — опитуємо історію.

   У браузері зберігаються лише: випадковий id відвідувача (щоб історія
   пережила перехід між сторінками) і дрібниці на кшталт «чат відкритий».
   Жодних токенів тут немає.
   ========================================================================== */
(function () {
  'use strict';

  var configNode = document.getElementById('ukr-chat-config');
  if (!configNode || window.__ukrChat) return;
  window.__ukrChat = true;

  var CONFIG;
  try {
    CONFIG = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var API = String(CONFIG.api || '').replace(/\/+$/, '');
  if (!API) return;

  var KEY_VISITOR = 'ukrtec-chat-visitor';
  var KEY_STARTED = 'ukrtec-chat-started';
  var KEY_SEEN = 'ukrtec-chat-seen';
  var KEY_OPEN = 'ukrtec-chat-open';
  var KEY_DRAFT = 'ukrtec-chat-draft';
  var KEY_CONFIG = 'ukrtec-chat-config';
  var KEY_CONTACT = 'ukrtec-chat-contact';

  var TEXT_MAX = 2000;
  var PHOTO_MAX = 5 * 1024 * 1024;
  var POLL_OPEN_MS = 4000;
  /* Фоновий WebSocket (для значка «нове повідомлення») тримаємо лише
     добу після останньої активності, далі — тільки коли чат відкритий. */
  var BACKGROUND_MS = 24 * 3600 * 1000;

  /* ── Сховище: у приватному режимі може кидати помилки ─────────────────── */

  function storageGet(kind, key) {
    try {
      return window[kind].getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(kind, key, value) {
    try {
      if (value == null) window[kind].removeItem(key);
      else window[kind].setItem(key, String(value));
    } catch (error) {
      /* нічого страшного — працюємо без пам'яті */
    }
  }

  function visitorId() {
    var id = storageGet('localStorage', KEY_VISITOR);
    if (id && /^[a-f0-9]{32}$/.test(id)) return id;
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    id = Array.prototype.map
      .call(bytes, function (byte) {
        return ('0' + byte.toString(16)).slice(-2);
      })
      .join('');
    storageSet('localStorage', KEY_VISITOR, id);
    return id;
  }

  /* ── Стан ─────────────────────────────────────────────────────────────── */

  var VISITOR = visitorId();
  window.ukrChatVisitor = function () {
    // np-checkout.js додає це до замовлення, якщо покупець писав у чат.
    return storageGet('localStorage', KEY_STARTED) ? VISITOR : '';
  };

  var state = {
    online: true,
    open: false,
    started: Boolean(storageGet('localStorage', KEY_STARTED)),
    activeAt: Number(storageGet('localStorage', KEY_STARTED)) || 0,
    loaded: false,
    messages: [],
    lastId: 0,
    seenId: Number(storageGet('localStorage', KEY_SEEN) || 0),
    status: 'none',
    agent: null,
    socket: null,
    socketOk: false,
    retry: 0,
    pollTimer: null,
    pending: 0,
    contactGiven: Boolean(storageGet('localStorage', KEY_CONTACT)),
    contactDismissed: null
  };

  var nodes = {};

  /* ── DOM ──────────────────────────────────────────────────────────────── */

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  var ICON_CHAT =
    '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M4 5h16v11H9l-5 4V5z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M8 9.5h8M8 12.5h5" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>';
  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="square"/></svg>';
  var ICON_SEND =
    '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M4 12l16-8-6 16-2.5-6.5L4 12z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var ICON_PHOTO =
    '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><rect x="3.5" y="5.5" width="17" height="13" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="9" cy="10" r="1.6" fill="currentColor"/><path d="M4 17l5-4.5 3.5 3 3-2.5L20 17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';

  function build() {
    var root = el('div', 'ukr-chat');
    root.setAttribute('data-state', 'closed');

    /* Кнопка */
    var launcher = el('button', 'ukr-chat__launcher');
    launcher.type = 'button';
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-controls', 'ukr-chat-panel');
    launcher.innerHTML = ICON_CHAT;
    var launcherLabel = el('span', 'ukr-chat__launcher-label', CONFIG.button || 'Запитати консультанта');
    launcher.appendChild(launcherLabel);
    var badge = el('span', 'ukr-chat__badge');
    badge.hidden = true;
    launcher.appendChild(badge);

    /* Превʼю відповіді, коли панель закрита */
    var preview = el('button', 'ukr-chat__preview');
    preview.type = 'button';
    preview.hidden = true;

    /* Панель */
    var panel = el('section', 'ukr-chat__panel');
    panel.id = 'ukr-chat-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', CONFIG.title || 'Чат з консультантом');
    panel.hidden = true;

    var header = el('header', 'ukr-chat__header');
    var heading = el('div', 'ukr-chat__heading');
    heading.appendChild(el('p', 'ukr-chat__title', CONFIG.title || 'Консультант UKR-TEC'));
    var status = el('p', 'ukr-chat__status');
    heading.appendChild(status);
    var close = el('button', 'ukr-chat__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Закрити чат');
    close.innerHTML = ICON_CLOSE;
    header.appendChild(heading);
    header.appendChild(close);

    var log = el('div', 'ukr-chat__log');
    log.setAttribute('role', 'log');
    log.setAttribute('aria-live', 'polite');
    log.tabIndex = 0;

    var intro = el('div', 'ukr-chat__intro');
    if (CONFIG.greeting) intro.appendChild(el('p', 'ukr-chat__bubble ukr-chat__bubble--agent', CONFIG.greeting));
    log.appendChild(intro);

    var list = el('ol', 'ukr-chat__list');
    log.appendChild(list);

    var contact = buildContactForm();
    log.appendChild(contact.node);

    var error = el('p', 'ukr-chat__error');
    error.hidden = true;
    error.setAttribute('role', 'alert');

    var form = el('form', 'ukr-chat__composer');
    form.noValidate = true;
    var attach = el('label', 'ukr-chat__icon-button');
    attach.title = 'Надіслати фото';
    attach.innerHTML = ICON_PHOTO + '<span class="ukr-chat__sr">Надіслати фото</span>';
    var fileInput = el('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/jpeg,image/png,image/webp';
    fileInput.className = 'ukr-chat__sr';
    attach.appendChild(fileInput);

    var textarea = el('textarea', 'ukr-chat__input');
    textarea.rows = 1;
    textarea.maxLength = TEXT_MAX;
    textarea.placeholder = 'Напишіть повідомлення…';
    textarea.setAttribute('aria-label', 'Повідомлення');
    textarea.value = storageGet('sessionStorage', KEY_DRAFT) || '';

    var send = el('button', 'ukr-chat__icon-button ukr-chat__send');
    send.type = 'submit';
    send.innerHTML = ICON_SEND + '<span class="ukr-chat__sr">Надіслати</span>';

    form.appendChild(attach);
    form.appendChild(textarea);
    form.appendChild(send);

    var footnote = el('p', 'ukr-chat__footnote');
    if (CONFIG.privacyUrl) {
      footnote.appendChild(document.createTextNode('Надсилаючи повідомлення, ви погоджуєтесь із '));
      var link = el('a', null, 'політикою конфіденційності');
      link.href = CONFIG.privacyUrl;
      link.target = '_blank';
      link.rel = 'noopener';
      footnote.appendChild(link);
    } else {
      footnote.hidden = true;
    }

    panel.appendChild(header);
    panel.appendChild(log);
    panel.appendChild(error);
    panel.appendChild(form);
    panel.appendChild(footnote);

    root.appendChild(panel);
    root.appendChild(preview);
    root.appendChild(launcher);
    document.body.appendChild(root);

    nodes = {
      root: root,
      launcher: launcher,
      badge: badge,
      preview: preview,
      panel: panel,
      status: status,
      close: close,
      log: log,
      list: list,
      contact: contact,
      error: error,
      form: form,
      textarea: textarea,
      send: send,
      fileInput: fileInput
    };

    launcher.addEventListener('click', function () {
      setOpen(!state.open);
    });
    preview.addEventListener('click', function () {
      setOpen(true);
    });
    close.addEventListener('click', function () {
      setOpen(false);
      launcher.focus();
    });
    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        setOpen(false);
        launcher.focus();
      }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      sendText();
    });
    textarea.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
        event.preventDefault();
        sendText();
      }
    });
    textarea.addEventListener('input', function () {
      autosize();
      storageSet('sessionStorage', KEY_DRAFT, textarea.value || null);
    });
    fileInput.addEventListener('change', function () {
      var file = fileInput.files && fileInput.files[0];
      fileInput.value = '';
      if (file) sendPhoto(file);
    });
  }

  function buildContactForm() {
    var node = el('form', 'ukr-chat__contact');
    node.noValidate = true;
    node.hidden = true;
    var title = el('p', 'ukr-chat__contact-title', 'Залиште номер — передзвонимо');
    var name = el('input', 'ukr-chat__field');
    name.type = 'text';
    name.name = 'name';
    name.autocomplete = 'given-name';
    name.placeholder = "Ім'я";
    name.maxLength = 60;
    name.setAttribute('aria-label', "Ім'я");
    var phone = el('input', 'ukr-chat__field');
    phone.type = 'tel';
    phone.name = 'phone';
    phone.autocomplete = 'tel';
    phone.inputMode = 'tel';
    phone.placeholder = '+380 __ ___ __ __';
    phone.setAttribute('aria-label', 'Телефон');
    var actions = el('div', 'ukr-chat__contact-actions');
    var submit = el('button', 'ukr-chat__button', 'Надіслати');
    submit.type = 'submit';
    var skip = el('button', 'ukr-chat__link', 'Не зараз');
    skip.type = 'button';
    actions.appendChild(submit);
    actions.appendChild(skip);
    node.appendChild(title);
    node.appendChild(name);
    node.appendChild(phone);
    node.appendChild(actions);

    node.addEventListener('submit', function (event) {
      event.preventDefault();
      sendContact(name.value, phone.value, submit);
    });
    skip.addEventListener('click', function () {
      state.contactDismissed = contactKey();
      renderContact();
    });
    return { node: node, name: name, phone: phone, submit: submit };
  }

  function autosize() {
    var area = nodes.textarea;
    area.style.height = 'auto';
    area.style.height = Math.min(area.scrollHeight, 120) + 'px';
  }

  /* ── Відкрити / закрити ───────────────────────────────────────────────── */

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function setOpen(open) {
    state.open = open;
    nodes.panel.hidden = !open;
    nodes.root.setAttribute('data-state', open ? 'open' : 'closed');
    nodes.launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
    nodes.launcher.setAttribute('aria-label', open ? 'Закрити чат' : CONFIG.button || 'Запитати консультанта');
    document.documentElement.classList.toggle('ukr-chat-lock', open && isMobile());
    storageSet('sessionStorage', KEY_OPEN, open ? '1' : null);

    if (open) {
      nodes.preview.hidden = true;
      if (state.started && !state.loaded) loadHistory();
      markSeen();
      autosize();
      scrollDown();
      if (!isMobile()) nodes.textarea.focus();
      ensureTransport();
    } else {
      stopPolling();
    }
  }

  /* ── Малювання повідомлень ────────────────────────────────────────────── */

  function timeOf(ts) {
    try {
      return new Date(ts).toLocaleTimeString('uk-UA', { hour: '2-digit', minute: '2-digit' });
    } catch (error) {
      return '';
    }
  }

  function renderMessage(message) {
    var item = el('li', 'ukr-chat__item ukr-chat__item--' + message.from);
    item.setAttribute('data-id', message.id);

    if (message.from === 'system') {
      item.appendChild(el('p', 'ukr-chat__system', message.text));
      return item;
    }

    if (message.from === 'agent' && message.name) {
      item.appendChild(el('span', 'ukr-chat__author', message.name));
    }

    var bubble = el('div', 'ukr-chat__bubble ukr-chat__bubble--' + (message.from === 'agent' ? 'agent' : 'visitor'));

    if (message.photo || message.localPhoto) {
      var link = el('a', 'ukr-chat__photo');
      var src = message.localPhoto || API + '/api/chat/file?v=' + VISITOR + '&m=' + message.id;
      link.href = src;
      link.target = '_blank';
      link.rel = 'noopener';
      var img = el('img');
      img.src = src;
      img.alt = message.text || 'Фото';
      img.loading = 'lazy';
      img.addEventListener('load', scrollDownIfNear);
      link.appendChild(img);
      bubble.appendChild(link);
    }

    if (message.kind === 'contact') {
      bubble.appendChild(el('span', 'ukr-chat__text', '📞 ' + message.text));
    } else if (message.text) {
      bubble.appendChild(el('span', 'ukr-chat__text', message.text));
    }

    item.appendChild(bubble);

    var meta = el('span', 'ukr-chat__meta');
    if (message.failed) {
      meta.classList.add('ukr-chat__meta--failed');
      meta.textContent = 'Не надіслано · ';
      var retry = el('button', 'ukr-chat__link', 'повторити');
      retry.type = 'button';
      retry.addEventListener('click', function () {
        retryMessage(message);
      });
      meta.appendChild(retry);
    } else {
      meta.textContent = message.sending ? 'Надсилається…' : timeOf(message.ts);
    }
    item.appendChild(meta);
    if (message.sending) item.classList.add('is-sending');
    return item;
  }

  function renderAll() {
    var list = nodes.list;
    var nearBottom = isNearBottom();
    list.textContent = '';
    for (var i = 0; i < state.messages.length; i += 1) {
      list.appendChild(renderMessage(state.messages[i]));
    }
    renderContact();
    renderStatus();
    if (nearBottom) scrollDown();
  }

  /* Яке саме прохання про телефон зараз показане: «Не зараз» ховає лише його,
     а наступне прохання консультанта знову покаже форму. */
  function contactKey() {
    var key = 'offline';
    for (var i = 0; i < state.messages.length; i += 1) {
      if (state.messages[i].kind === 'contact_request') key = 'request-' + state.messages[i].id;
    }
    return key;
  }

  function renderContact() {
    var messages = state.messages;
    var lastRequest = -1;
    var lastContact = -1;
    var visitorWrote = false;
    for (var i = 0; i < messages.length; i += 1) {
      if (messages[i].kind === 'contact_request') lastRequest = i;
      if (messages[i].kind === 'contact') lastContact = i;
      if (messages[i].from === 'visitor') visitorWrote = true;
    }

    var asked = lastRequest > lastContact;
    // Неробочий час: пропонуємо телефон одразу після першого повідомлення.
    var offlineAsk = !state.online && visitorWrote && lastContact < 0 && !state.contactGiven;
    var show = (asked || offlineAsk) && state.contactDismissed !== contactKey();

    nodes.contact.node.hidden = !show;
    if (show) scrollDownIfNear();
  }

  function renderStatus() {
    var text;
    if (state.agent && state.status === 'active') {
      text = state.agent + ' відповідає вам';
    } else if (state.online) {
      text = 'Онлайн · відповідаємо за кілька хвилин';
    } else {
      text = 'Зараз неробочий час' + (CONFIG.hours ? ' · ' + CONFIG.hours : '');
    }
    nodes.status.textContent = text;
    nodes.root.classList.toggle('is-offline', !state.online);
  }

  function isNearBottom() {
    var log = nodes.log;
    return log.scrollHeight - log.scrollTop - log.clientHeight < 80;
  }

  function scrollDown() {
    var log = nodes.log;
    log.scrollTop = log.scrollHeight;
  }

  function scrollDownIfNear() {
    if (isNearBottom()) scrollDown();
  }

  function showError(text) {
    nodes.error.textContent = text || '';
    nodes.error.hidden = !text;
  }

  /* ── Непрочитані ──────────────────────────────────────────────────────── */

  function markSeen() {
    var last = 0;
    for (var i = 0; i < state.messages.length; i += 1) {
      if (typeof state.messages[i].id === 'number') last = Math.max(last, state.messages[i].id);
    }
    state.seenId = Math.max(state.seenId, last);
    storageSet('localStorage', KEY_SEEN, state.seenId);
    updateBadge();
  }

  function updateBadge() {
    var unread = state.messages.filter(function (message) {
      return message.from !== 'visitor' && typeof message.id === 'number' && message.id > state.seenId;
    });
    if (state.open) {
      nodes.badge.hidden = true;
      return;
    }
    nodes.badge.hidden = unread.length === 0;
    nodes.badge.textContent = unread.length > 9 ? '9+' : String(unread.length);
    nodes.root.classList.toggle('has-unread', unread.length > 0);

    var last = unread[unread.length - 1];
    if (last && last.text) {
      nodes.preview.textContent = (last.name ? last.name + ': ' : '') + last.text;
      nodes.preview.hidden = false;
    } else {
      nodes.preview.hidden = true;
    }
  }

  /* ── Мережа ───────────────────────────────────────────────────────────── */

  function request(path, options) {
    return fetch(API + path, options).then(function (response) {
      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!response.ok || data.ok === false) {
            var error = new Error(data.error || 'Не вдалося надіслати. Спробуйте ще раз.');
            error.status = response.status;
            throw error;
          }
          return data;
        });
    });
  }

  function addMessages(incoming) {
    var changed = false;
    for (var i = 0; i < incoming.length; i += 1) {
      var message = incoming[i];
      var exists = state.messages.some(function (item) {
        return item.id === message.id;
      });
      if (exists) continue;
      state.messages.push(message);
      state.lastId = Math.max(state.lastId, message.id);
      changed = true;
    }
    if (!changed) return;
    state.messages.sort(function (a, b) {
      var left = typeof a.id === 'number' ? a.id : Infinity;
      var right = typeof b.id === 'number' ? b.id : Infinity;
      return left - right;
    });
    renderAll();
    if (state.open && !document.hidden) markSeen();
    else updateBadge();
  }

  function applyStatus(payload) {
    if (!payload) return;
    state.status = payload.status;
    state.agent = payload.agent;
    renderStatus();
  }

  function loadHistory() {
    var first = !state.loaded;
    return request('/api/chat/history?v=' + VISITOR + '&after=' + state.lastId)
      .then(function (data) {
        state.loaded = true;
        applyStatus(data.status);
        addMessages(data.messages || []);
        if (!data.messages || (!data.messages.length && !state.messages.length)) renderAll();
        if (first) scrollDown();
      })
      .catch(function () {
        /* мовчки — спробуємо пізніше */
      });
  }

  function touchActivity() {
    state.activeAt = Date.now();
    storageSet('localStorage', KEY_STARTED, state.activeAt);
  }

  function ensureTransport() {
    if (!state.started) return;
    if (!state.open && Date.now() - state.activeAt > BACKGROUND_MS) return;
    if (!window.WebSocket) {
      startPolling();
      return;
    }
    if (state.socket) return;
    connect();
  }

  function connect() {
    var url = API.replace(/^http/, 'ws') + '/api/chat/ws?v=' + VISITOR;
    var socket;
    try {
      socket = new WebSocket(url);
    } catch (error) {
      startPolling();
      return;
    }
    state.socket = socket;
    var pingTimer = null;

    socket.addEventListener('open', function () {
      state.socketOk = true;
      state.retry = 0;
      stopPolling();
      // Могли щось пропустити, поки зʼєднання не було.
      loadHistory();
      pingTimer = setInterval(function () {
        if (socket.readyState === 1) socket.send('ping');
      }, 45000);
    });

    socket.addEventListener('message', function (event) {
      if (event.data === 'pong') return;
      var payload;
      try {
        payload = JSON.parse(event.data);
      } catch (error) {
        return;
      }
      if (payload.type === 'message') {
        touchActivity();
        addMessages([payload.message]);
      }
      if (payload.type === 'status') applyStatus(payload);
      if (payload.type === 'edit') {
        state.messages.forEach(function (message) {
          if (message.id === payload.message.id) message.text = payload.message.text;
        });
        renderAll();
      }
    });

    socket.addEventListener('close', function () {
      clearInterval(pingTimer);
      state.socket = null;
      state.socketOk = false;
      if (state.open) startPolling();
      state.retry += 1;
      var delay = Math.min(30000, 1000 * Math.pow(2, state.retry));
      setTimeout(function () {
        if (!state.socket && !document.hidden) ensureTransport();
      }, delay);
    });
  }

  function startPolling() {
    if (state.pollTimer || !state.open) return;
    state.pollTimer = setInterval(function () {
      if (!document.hidden) loadHistory();
    }, POLL_OPEN_MS);
  }

  function stopPolling() {
    clearInterval(state.pollTimer);
    state.pollTimer = null;
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden || !state.started) return;
    loadHistory();
    if (!state.socket) ensureTransport();
    if (state.open) markSeen();
  });

  /* Що бачить консультант у першому повідомленні: сторінка, товар, кошик. */
  function collectContext() {
    var context = {
      url: window.location.href,
      title: document.title,
      referrer: document.referrer && document.referrer.indexOf(window.location.origin) !== 0 ? document.referrer : '',
      product: CONFIG.product || null
    };
    if (state.messages.some(isServerMessage)) return Promise.resolve(context);

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        context.cart = {
          count: cart.item_count,
          total: cart.total_price / 100,
          currency: cart.currency || CONFIG.currency,
          items: (cart.items || []).slice(0, 10).map(function (item) {
            return { title: item.product_title + (item.variant_title ? ' — ' + item.variant_title : ''), quantity: item.quantity };
          })
        };
        return context;
      })
      .catch(function () {
        return context;
      });
  }

  function isServerMessage(message) {
    return typeof message.id === 'number';
  }

  function markStarted() {
    touchActivity();
    if (state.started) return;
    state.started = true;
    state.loaded = true;
    ensureTransport();
  }

  function replaceLocal(local, saved) {
    var index = state.messages.indexOf(local);
    if (index !== -1) state.messages.splice(index, 1);
    addMessages([saved]);
    renderAll();
  }

  function failLocal(local, error) {
    local.sending = false;
    local.failed = true;
    showError(error.message);
    renderAll();
  }

  function setPending(delta) {
    state.pending += delta;
  }

  function sendText() {
    var text = nodes.textarea.value.trim();
    if (!text) return;
    nodes.textarea.value = '';
    storageSet('sessionStorage', KEY_DRAFT, null);
    autosize();
    showError('');

    var local = { id: 'local-' + Date.now(), from: 'visitor', kind: 'text', text: text, sending: true };
    state.messages.push(local);
    renderAll();
    scrollDown();
    deliverText(local);
  }

  function deliverText(local) {
    setPending(1);
    collectContext()
      .then(function (context) {
        return request('/api/chat/send', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ v: VISITOR, text: local.text, context: context })
        });
      })
      .then(function (data) {
        markStarted();
        applyStatus(data.status);
        replaceLocal(local, data.message);
      })
      .catch(function (error) {
        failLocal(local, error);
      })
      .then(function () {
        setPending(-1);
      });
  }

  function retryMessage(local) {
    local.failed = false;
    local.sending = true;
    showError('');
    renderAll();
    if (local.file) deliverPhoto(local);
    else deliverText(local);
  }

  function sendPhoto(file) {
    showError('');
    if (['image/jpeg', 'image/png', 'image/webp'].indexOf(file.type) === -1) {
      showError('Можна надіслати фото JPG, PNG або WebP.');
      return;
    }
    if (file.size > PHOTO_MAX) {
      showError('Фото завелике — до 5 МБ.');
      return;
    }
    var caption = nodes.textarea.value.trim();
    nodes.textarea.value = '';
    storageSet('sessionStorage', KEY_DRAFT, null);
    autosize();

    var local = {
      id: 'local-' + Date.now(),
      from: 'visitor',
      kind: 'photo',
      text: caption,
      localPhoto: URL.createObjectURL(file),
      file: file,
      sending: true
    };
    state.messages.push(local);
    renderAll();
    scrollDown();
    deliverPhoto(local);
  }

  function deliverPhoto(local) {
    setPending(1);
    collectContext()
      .then(function (context) {
        var body = new FormData();
        body.append('v', VISITOR);
        body.append('caption', local.text || '');
        body.append('context', JSON.stringify(context));
        body.append('file', local.file, local.file.name || 'photo');
        return request('/api/chat/photo', { method: 'POST', body: body });
      })
      .then(function (data) {
        markStarted();
        applyStatus(data.status);
        // Лишаємо локальне превʼю, щоб картинка не перезавантажувалась.
        data.message.localPhoto = local.localPhoto;
        replaceLocal(local, data.message);
      })
      .catch(function (error) {
        failLocal(local, error);
      })
      .then(function () {
        setPending(-1);
      });
  }

  function sendContact(name, phone, button) {
    var digits = String(phone || '').replace(/\D/g, '');
    if (digits.length < 10) {
      showError('Перевірте номер телефону.');
      nodes.contact.phone.focus();
      return;
    }
    showError('');
    button.disabled = true;

    collectContext()
      .then(function (context) {
        return request('/api/chat/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ v: VISITOR, name: name, phone: phone, context: context })
        });
      })
      .then(function (data) {
        state.contactGiven = true;
        storageSet('localStorage', KEY_CONTACT, '1');
        markStarted();
        applyStatus(data.status);
        addMessages([data.message]);
      })
      .catch(function (error) {
        showError(error.message);
      })
      .then(function () {
        button.disabled = false;
      });
  }

  /* ── Старт ────────────────────────────────────────────────────────────── */

  function loadConfig() {
    var cached = storageGet('sessionStorage', KEY_CONFIG);
    if (cached) {
      try {
        var parsed = JSON.parse(cached);
        if (parsed && Date.now() - parsed.at < 5 * 60 * 1000) return Promise.resolve(parsed.data);
      } catch (error) {
        /* зіпсований кеш — перезапитаємо */
      }
    }
    return request('/api/chat/config').then(function (data) {
      storageSet('sessionStorage', KEY_CONFIG, JSON.stringify({ at: Date.now(), data: data }));
      return data;
    });
  }

  function start() {
    loadConfig()
      .then(function (config) {
        if (!config || !config.enabled) return;
        state.online = Boolean(config.online);
        build();
        renderAll();

        if (state.started) {
          loadHistory().then(function () {
            ensureTransport();
          });
        }
        if (storageGet('sessionStorage', KEY_OPEN) === '1') setOpen(true);
      })
      .catch(function () {
        /* бекенд недоступний — віджет просто не показуємо */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
